import React from 'react';
import { Toast } from 'react-bootstrap';
import { Warning } from '@material-ui/icons';

export default class ErrorToast extends React.Component {

    render() {
        return (
            <Toast
                onClose={() => this.props.onClose(this.props.error)}
                show={true}>
                <Toast.Header style={{ backgroundColor: "#EA4335", color: "white" }}>
                    <Warning />
                    {/* <strong className="mr-auto" style={{ paddingLeft: "0.5rem" }}> ERROR {this.props.error.status}</strong> */}
                    <strong className="mr-auto" style={{ paddingLeft: "0.5rem" }}>{this.props.error.statusText}</strong>
                </Toast.Header>
                <Toast.Body>{this.props.error.data ? this.props.error.data : this.props.error.statusText}</Toast.Body>
            </Toast>);
    }
};